import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityActividadesGrupoEspecieAddFailure,
  entityActividadesGrupoEspecieAddRequest,
  entityActividadesGrupoEspecieAddSuccess,
  entityActividadesGrupoEspecieLoadFailure,
  entityActividadesGrupoEspecieLoadRequest,
  entityActividadesGrupoEspecieLoadSuccess
} from './entity-actividades-grupo-especie.actions';

import { ActividadesGrupoEspecieService } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class ActividadesGrupoEspecieEffects {
  // load
  loadRequestActividadesGrupoEspecie = createEffect(() =>
    this.actions$.pipe(
      ofType(entityActividadesGrupoEspecieLoadRequest),
      mergeMap(() =>
        this.actividadesGrupoEspecieService.getActividadesGrupoEspecie().pipe(
          map((items) => entityActividadesGrupoEspecieLoadSuccess({ items })),
          catchError((error) => of(entityActividadesGrupoEspecieLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestActividadGrupoEspecie = createEffect(() =>
    this.actions$.pipe(
      ofType(entityActividadesGrupoEspecieAddRequest),
      switchMap((action) =>
        this.actividadesGrupoEspecieService.addActividadGrupoEspecie(action.item).pipe(
          map((item) => entityActividadesGrupoEspecieAddSuccess({ item: item.actividad_grupos_especie })),
          catchError((error) => of(entityActividadesGrupoEspecieAddFailure({ error })))
        )
      )
    )
  );

  addSuccessActividadGrupoEspecie = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityActividadesGrupoEspecieAddSuccess),
        // tap(() => this.router.navigate(['']))
        tap(() => null)
      ),
    { dispatch: false }
  );

  // change

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private actividadesGrupoEspecieService: ActividadesGrupoEspecieService,
    private router: Router
  ) {
    this.actividadesGrupoEspecieService.url = environment.apiUrl;
  }
}
